/* ══════════════════════════════════════════════════════════════════════
   LA HOJA «ENTENDER» · CÓDIGO TRAÍDO DE FISIOVISIÓN, TAL CUAL
   ----------------------------------------------------------------------
   Esto NO está reescrito: es la función `verHoja()` del prototipo
   (02-CODIGO/v2/prototipo/paciente.html), con sus ayudantes, copiada.
   Lo único que se ha tocado es de dónde entran los datos y que en vez de
   escribir en el DOM DEVUELVE el HTML, para poder pintarlo desde React.

   El diseño manda desde el prototipo. Si algo hay que cambiar, se cambia
   ALLÍ y se vuelve a traer — no aquí, o en dos meses hay dos hojas
   distintas y nadie sabe cuál es la buena.
   ══════════════════════════════════════════════════════════════════════ */

var ICO_HOJA = {
  alargar:  '<path d="M12 21V3"/><path d="M8 6.5l4-3.5 4 3.5"/><path d="M8 17.5l4 3.5 4-3.5"/>',
  mover:    '<circle cx="12" cy="4.6" r="2.1"/><path d="M12 8v6l-3 6"/><path d="M12 14l3.5 6"/><path d="M6.5 10.5L12 9l5.5 1.5"/>',
  fortalecer:'<path d="M4 9v6"/><path d="M20 9v6"/><path d="M7 7v10"/><path d="M17 7v10"/><path d="M7 12h10"/>',
  pauta:    '<rect x="4" y="4.5" width="16" height="16" rx="3"/><path d="M8 3v3M16 3v3M4 10h16"/><path d="M9 14.5l2 2 4-4"/>',
  cuentanos:'<path d="M20 14.5a2.5 2.5 0 0 1-2.5 2.5H9l-4 3.5V6.5A2.5 2.5 0 0 1 7.5 4h10A2.5 2.5 0 0 1 20 6.5z"/>'
};

function icoHoja(k){
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
         (ICO_HOJA[k]||'')+'</svg>';
}

function faltaLamina(txt, alto){
  return '<div class="fv-hoja__falta"'+(alto ? ' style="min-height:'+alto+'px"' : '')+'>'+
           '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="3"/><circle cx="9" cy="10" r="2"/><path d="M3 17l5-4 4 3 3-2 6 5"/></svg>'+
           '<span>'+txt+'</span></div>';
}

function bloqueLaminas(b, rotPorDefecto, dentro){
  if(!b || !(b.imgs && b.imgs.length)) return '';
  return (dentro ? '<h4>'+(b.rot || rotPorDefecto)+'</h4>' : '<section class="fv-hoja__b"><h3>'+(b.rot || rotPorDefecto)+'</h3>')+
    '<div class="fv-hoja__mueve">'+
      b.imgs.map(function(x){
        return '<figure>'+(x.img ? '<img src="'+x.img+'" alt="">' : faltaLamina('', 130))+
               '<figcaption><b>'+x.t+'</b>'+(x.d||'')+'</figcaption></figure>';
      }).join('')+
    '</div>'+
    (b.texto ? '<p class="fv-hoja__mueve-tx">'+b.texto+'</p>' : '')+
    (dentro ? '' : '</section>');
}

/* Las dos que faltaban al traer verHoja(): en el prototipo viven fuera de la
   función y no entraron en el corte. Sin ellas, abrir una hoja reventaba. */
function hojaTieneContenido(h){
  return !!(h && (h.que_pasa || h.quedate || h.objetivos));
}
function atrasHoja(){
  return '<button class="fv-hoja__atras" data-atras="1">'+
    '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" '+
    'stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
    '<path d="M15 6l-6 6 6 6"/></svg>Entender</button>';
}

function _verHoja(h, EJERCICIOS, pasosDe, HOJA_ABIERTA, fisio){
  if(!h) return '';
  if(!hojaTieneContenido(h)){
    return '<div class="fv-hoja">'+ atrasHoja() +
        '<h2 class="fv-hoja__tit">'+h.titulo+'</h2>'+
        (h.subtitulo ? '<p class="fv-hoja__sub">'+h.subtitulo+'</p>' : '')+
        '<div class="fv-hoja__falta" style="min-height:200px">Esta hoja todavía no está escrita</div>'+
      '</div>';
  }

  /* ---- los ejercicios de SU pauta, por referencia ---- */
  /* ---- 5 · LOS EJERCICIOS SALEN DE LA PAUTA ACTIVA ----
     Ann, 12-ago-2026: «no escribir ejercicios fijos dentro de la
     plantilla educativa; obtenerlos de la pauta activa del paciente».

     Cómo: la hoja NO lleva lista de ejercicios. Lleva un PORQUÉ por
     ejercicio, y se recorre LA PAUTA DE VERDAD enseñando los que estén.
     Consecuencia buscada: si su fisio no se lo ha mandado, no lo ve.
     La hoja no puede enseñar un ejercicio que el paciente no tiene. */
  var ejs = '';
  for(var q = 0, puestos = 0; q < EJERCICIOS.length && puestos < 3; q++){
    var porque = h.porques && h.porques[q];
    if(!porque) continue;
    var ee = EJERCICIOS[q], Pq = pasosDe(q);
    var fotoq = (Pq && Pq[1]) ? Pq[1].foto : null;
    ejs += '<button class="fv-hoja__ej" data-ej="'+q+'">'+
             (fotoq ? '<img src="'+fotoq+'" alt="">' : '<span class="fv-hoja__ej-sinfoto"></span>')+
             '<span><b>'+ee.n+'</b>'+porque+'</span>'+
             '<svg class="fv-hoja__ej-fl" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>'+
           '</button>';
    puestos++;
  }

  /* ---- SABER MÁS · lo que existe pero NO ocupa la primera lectura ----
     Regla 4 de Ann (12-ago-2026): el contenido clínico de más puede
     existir, pero escondido. Así quien tiene curiosidad profundiza y al
     resto no se le castiga con una pared de texto.
     Va con <details>, que se abre EN SU SITIO: ni ventana, ni scroll
     interno, ni nada que salte. */
  var mas = '';
  if(h.que_pasa && h.que_pasa.mas) mas += '<p>'+h.que_pasa.mas+'</p>';
  mas += bloqueLaminas(h.equipo, 'No trabaja solo', true);
  mas += bloqueLaminas(h.como_se_mueve, '¿Cómo se mueve?', true);
  if(h.puedes_hacer && h.puedes_hacer.length){
    mas += '<h4>Qué puedes hacer tú</h4><div class="fv-hoja__metas">'+
      h.puedes_hacer.map(function(o){
        return '<div class="fv-hoja__meta es-accion"><span class="fv-hoja__meta-ico">'+icoHoja(o.ico)+'</span>'+
               '<div><b>'+o.t+'</b>'+o.d+'</div></div>';
      }).join('')+'</div>';
  }

  return '<div class="fv-hoja">'+ atrasHoja() +

    /* 1 · PORTADA · imagen grande y nada más */
    '<h2 class="fv-hoja__tit">'+h.titulo+'</h2>'+
    (h.subtitulo ? '<p class="fv-hoja__sub">'+h.subtitulo+'</p>' : '')+
    (h.hero
      ? '<figure class="fv-hoja__hero"><img src="'+h.hero+'" alt=""></figure>'
      : faltaLamina('La lámina de portada', 220))+

    /* 2 · QUÉ ESTÁ PASANDO · ilustración + explicación mínima */
    (h.que_pasa
      ? '<section class="fv-hoja__duo">'+
          '<div class="fv-hoja__duo-img">'+
            (h.que_pasa.img
              ? '<img src="'+h.que_pasa.img+'" alt="">'+(h.que_pasa.pie ? '<small>'+h.que_pasa.pie+'</small>' : '')
              : faltaLamina(h.que_pasa.pie || 'La ilustración', 180))+
          '</div>'+
          '<div class="fv-hoja__duo-tx"><h3>¿Qué está pasando?</h3>'+
            '<p>'+h.que_pasa.texto+'</p>'+
            ((h.que_pasa_leyenda && h.que_pasa_leyenda.length)
              ? '<ul class="fv-hoja__leyenda">'+ h.que_pasa_leyenda.map(function(x){
                  return '<li><i style="background:'+x.color+'"></i><span><b>'+x.t+'</b></span></li>';
                }).join('') +'</ul>'
              : '')+
          '</div>'+
        '</section>'
      : '')+

    /* 3 · QUÉ PUEDES NOTAR · TRES ESCENAS, SIN EXPLICACIÓN DEBAJO.
       Ann, 12-ago-2026: «no añadiría explicaciones debajo; las imágenes
       son las que convierten esas frases en algo comprensible». */
    ((h.notar && h.notar.length)
      ? '<section class="fv-hoja__b"><h3>¿Qué puedes notar?</h3>'+
          (h.notar_intro ? '<p class="fv-hoja__intro">'+h.notar_intro+'</p>' : '')+
          '<div class="fv-hoja__cards">'+
            h.notar.slice(0,3).map(function(c){
              return '<div class="fv-hoja__card">'+
                       (c.img ? '<img src="'+c.img+'" alt="">' : faltaLamina('', 92))+
                       '<b>'+c.t+'</b></div>';
            }).join('')+
          '</div></section>'
      : '')+

    /* 4 · QUÉ VAMOS A TRABAJAR · tres conceptos, tres frases */
    ((h.objetivos && h.objetivos.length)
      ? '<section class="fv-hoja__b"><h3>¿Qué vamos a trabajar?</h3>'+
          '<div class="fv-hoja__metas">'+
            h.objetivos.slice(0,3).map(function(o, k){
              return '<div class="fv-hoja__meta"><span class="fv-hoja__meta-n">'+(k+1)+'</span>'+
                     '<div><b>'+o.t+'</b>'+o.d+'</div></div>';
            }).join('')+
          '</div></section>'
      : '')+

    /* 5 · TUS EJERCICIOS TIENEN UN PORQUÉ · el bloque diferencial */
    (ejs
      ? '<section class="fv-hoja__b"><h3>Tus ejercicios tienen un porqué</h3>'+
          '<div class="fv-hoja__ejs">'+ejs+'</div></section>'
      : '')+

    /* 6 · QUÉDATE CON ESTO · UNA idea. Una. */
    ((h.quedate && h.quedate.length)
      ? '<section class="fv-hoja__quedate"><h3>Quédate con esto</h3>'+
          '<p>'+h.quedate[0]+'</p></section>'
      : '')+

    /* SABER MÁS · plegado. Todo lo demás vive aquí. */
    (mas
      ? '<details class="fv-hoja__mas"><summary>Quiero saber más</summary>'+
          '<div class="fv-hoja__mas-in">'+mas+'</div></details>'
      : '')+

    /* CUÁNDO AVISAR · se queda A LA VISTA, no dentro de «saber más».
       Es lo único de la hoja que no es educación: es seguridad, y una
       advertencia que hay que desplegar para verla no es advertencia. */
    ((h.cuando_consultar && h.cuando_consultar.length)
      ? '<section class="fv-hoja__b es-avisar"><h3>¿Cuándo debes avisar a tu fisio?</h3>'+
          '<ul class="fv-hoja__lista">'+h.cuando_consultar.map(function(x){ return '<li>'+x+'</li>'; }).join('')+'</ul>'+
        '</section>'
      : '')+

    /* 7 · el mensaje de su fisio */
    /* SU CARA · en el prototipo la foto era un fichero suelto («thais.png»),
       porque allí la fisio era siempre la misma. En el CRM la fisio es la
       de VERDAD, y el fichero no existe: salía el mensaje sin cara.
       (Ann, 28-ago-2026.) Sin foto no se pinta el hueco: se pinta solo el
       mensaje, igual que en la ficha del ejercicio. */
    (h.mensaje_fisio
      ? '<div class="fv-hoja__fisio">'+
          ((fisio && fisio.foto) ? '<img src="'+fisio.foto+'" alt="'+((fisio && fisio.nombre) || 'Tu fisioterapeuta')+'">' : '')+
          '<div><small>Mensaje de '+((fisio && fisio.nombre) ? fisio.nombre.split(' ')[0] : 'tu fisio')+'</small>«'+h.mensaje_fisio+'»</div>'+
        '</div>'
      : '')+

    /* 8 · LA ACCIÓN */
    '<button class="fv-hoja__ir" data-ir="pautas">Ver mi pauta'+
      '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>'+
  '</div>';
}

export default _verHoja;
